import { useAtom } from 'jotai';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Select, SelectTrigger, SelectValue, SelectItem, SelectContent } from './ui/select';
import { dynamicActivate } from '../i18n';
import { localeAtom } from '../lib/atoms';

const LANGUAGE_ITEMS = { en: 'English', et: 'Eesti keel', ru: 'Русский' };

const Header = () => {
  const [locale, setLocale] = useAtom(localeAtom);
  const [searchParams, setSearchParams] = useSearchParams();

  // Sync URL param with locale state
  useEffect(() => {
    const langParam = searchParams.get('lang');
    if (langParam && (langParam === 'en' || langParam === 'et' || langParam === 'ru')) {
      if (langParam !== locale) {
        // Switch the atom (which remounts the I18nProvider) only once the catalog is active
        dynamicActivate(langParam).then(() => setLocale(langParam));
      }
    } else if (!searchParams.has('lang')) {
      // Set default lang in URL if not present
      setSearchParams({ lang: locale }, { replace: true });
    }
  }, [searchParams, locale, setLocale, setSearchParams]);

  const handleLanguageChange = async (newLocale: string) => {
    await dynamicActivate(newLocale);
    setLocale(newLocale);
    setSearchParams({ lang: newLocale });
  };

  return (
    <div className="flex w-full justify-between items-center gap-2">
      <img src="/logo.svg" alt="Transpor Diamet" className="h-9 w-auto" />

      <Select items={LANGUAGE_ITEMS} value={locale} onValueChange={(value) => value && handleLanguageChange(value)}>
        <SelectTrigger className="w-[120px] h-8">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">English</SelectItem>
          <SelectItem value="et">Eesti keel</SelectItem>
          <SelectItem value="ru">Русский</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default Header;
